import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../options/header";

const BASE_URL_SERVICES = process.env.VUE_APP_API_ENDPOINT_STARTER + '/office-management/services';
const BASE_URL_ASSETS = process.env.VUE_APP_API_ENDPOINT_STARTER + '/office-management/assets';


// Purchases
const getAllPurchases = async () => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchases`);
  } catch (error) {
    console.error("Failed to fetch purchases:", error);
  }
};

const getPurchaseById = async (id) => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchases/${id}`);
  } catch (error) {
    console.error(`Failed to fetch purchase with ID ${id}:`, error);
  }
};

const createPurchase = async (purchaseData) => {
  try {
    return await axiosPost(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchases`, purchaseData);
  } catch (error) {
    console.error("Failed to create purchase:", error);
  }
};

const updatePurchase = async (id, purchaseData) => {
  try {
    return await axiosPut(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchases/${id}`, purchaseData);
  } catch (error) {
    console.error(`Failed to update purchase with ID ${id}:`, error);
  }
};

const deletePurchase = async (id) => {
  try {
    return await axiosDelete(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchases/${id}`);
  } catch (error) {
    console.error(`Failed to delete purchase with ID ${id}:`, error);
  }
};

// Service Types
const getAllServiceTypes = async () => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/service-types`);
  } catch (error) {
    console.error("Failed to fetch service types:", error);
  }
};

const getServiceTypeById = async (id) => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/service-types/${id}`);
  } catch (error) {
    console.error(`Failed to fetch service type with ID ${id}:`, error);
  }
};

const createServiceType = async (serviceTypeData) => {
  try {
    return await axiosPost(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/service-types`, serviceTypeData);
  } catch (error) {
    console.error("Failed to create service type:", error);
  }
};

const updateServiceType = async (id, serviceTypeData) => {
  try {
    return await axiosPut(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/service-types/${id}`, serviceTypeData);
  } catch (error) {
    console.error(`Failed to update service type with ID ${id}:`, error);
  }
};

const deleteServiceType = async (id) => {
  try {
    return await axiosDelete(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/service-types/${id}`);
  } catch (error) {
    console.error(`Failed to delete service type with ID ${id}:`, error);
  }
};

// Purchase Groups
const getAllPurchaseGroups = async () => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchase-groups`);
  } catch (error) {
    console.error("Failed to fetch purchase groups:", error);
  }
};

const getPurchaseGroupById = async (id) => {
  try {
    return await axiosGet(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchase-groups/${id}`);
  } catch (error) {
    console.error(`Failed to fetch purchase group with ID ${id}:`, error);
  }
};

const createPurchaseGroup = async (purchaseGroupData) => {
  try {
    const formData = new FormData();
    Object.keys(purchaseGroupData).forEach(key => {
      if (key === 'files') {
        // purchaseGroupData.files.deleted.forEach(file => {
        //   formData.append('deletedFiles', file);
        // });
        // purchaseGroupData.files.previos.forEach(file => {
        //   formData.append('previosFiles', file);
        // });
        purchaseGroupData.files.new.forEach(file => {
          formData.append('files', file);
        });
      } else {
        formData.append(key, purchaseGroupData[key]);
      }
    });

    return await axiosPost(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchase-groups`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    console.error("Failed to create purchase group:", error);
  }
};

const updatePurchaseGroup = async (id, purchaseGroupData) => {
  try {
    const formData = new FormData();
    Object.keys(purchaseGroupData).forEach(key => {
      if (key === 'files') {
          purchaseGroupData.files.deleted.forEach(file => {
          formData.append('deletedFiles', file);
        });
        purchaseGroupData.files.previous.forEach(file => {
          formData.append('previousFiles', file);
        });
        purchaseGroupData.files.new.forEach(file => {
          formData.append('files', file);
        });
      } else {
        formData.append(key, purchaseGroupData[key]);
      }
    });

    return await axiosPut(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchase-groups/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    console.error(`Failed to update purchase group with ID ${id}:`, error);
  }
};

const deletePurchaseGroup = async (id) => {
  try {
    return await axiosDelete(`${process.env.VUE_APP_API_ENDPOINT_STARTER}/office-management/purchase-groups/${id}`);
  } catch (error) {
    console.error(`Failed to delete purchase group with ID ${id}:`, error);
  }
};


const fetchAllAssets = async () => {
  try {
      const response = await axiosGet(BASE_URL_ASSETS);
      return response.data;
  } catch (error) {
      console.error("Error fetching assets:", error);
      throw error;
  }
};

// Fetch a single asset by ID
const fetchAssetById = async (id) => {
  try {
      const response = await axiosGet(`${BASE_URL_ASSETS}/${id}`);
      return response.data;
  } catch (error) {
      console.error("Error fetching asset:", error);
      throw error;
  }
};

// Create a new asset
const createAsset = async (data, files) => {
  const formData = new FormData();
  for (const key in data) {
      formData.append(key, data[key]);
  }
  files.forEach(file => {
      formData.append('files', file);
  });
  try {
      const response = await axiosPost(BASE_URL_ASSETS, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error("Error creating asset:", error);
      throw error;
  }
};

// Update an existing asset
const updateAsset = async (id, data, files) => {
  const formData = new FormData();
  for (const key in data) {
      formData.append(key, data[key]);
  }
  files.forEach(file => {
      formData.append('files', file);
  });
  try {
      const response = await axiosPut(`${BASE_URL_ASSETS}/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error("Error updating asset:", error);
      throw error;
  }
};

// Delete an asset
const deleteAsset = async (id) => {
  try {
      const response = await axiosDelete(`${BASE_URL_ASSETS}/${id}`);
      return response.data;
  } catch (error) {
      console.error("Error deleting asset:", error);
      throw error;
  }
};

// Fetch all services
const fetchAllServices = async () => {
  try {
      const response = await axiosGet(BASE_URL_SERVICES);
      return response.data;
  } catch (error) {
      console.error("Error fetching services:", error);
      throw error;
  }
};

// Fetch a single service by ID
const fetchServiceById = async (id) => {
  try {
      const response = await axiosGet(`${BASE_URL_SERVICES}/${id}`);
      return response.data;
  } catch (error) {
      console.error("Error fetching service:", error);
      throw error;
  }
};

// Create a new service
const createService = async (data, files) => {
  const formData = new FormData();
  for (const key in data) {
      formData.append(key, data[key]);
  }
  files.forEach(file => {
      formData.append('files', file);
  });
  try {
      const response = await axiosPost(BASE_URL_SERVICES, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error("Error creating service:", error);
      throw error;
  }
};

// Update an existing service
const updateService = async (id, data, files) => {
  const formData = new FormData();
  for (const key in data) {
      formData.append(key, data[key]);
  }
  files.forEach(file => {
      formData.append('files', file);
  });
  try {
      const response = await axiosPut(`${BASE_URL_SERVICES}/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error("Error updating service:", error);
      throw error;
  }
};

// Delete a service
const deleteService = async (id) => {
  try {
      const response = await axiosDelete(`${BASE_URL_SERVICES}/${id}`);
      return response.data;
  } catch (error) {
      console.error("Error deleting service:", error);
      throw error;
  }
};

export {
  getAllPurchases,
  getPurchaseById,
  createPurchase,
  updatePurchase,
  deletePurchase,
  getAllServiceTypes,
  getServiceTypeById,
  createServiceType,
  updateServiceType,
  deleteServiceType,
  getAllPurchaseGroups,
  getPurchaseGroupById,
  createPurchaseGroup,
  updatePurchaseGroup,
  deletePurchaseGroup,
  fetchAllAssets,
    fetchAssetById,
    createAsset,
    updateAsset,
    deleteAsset,
    fetchAllServices,
    fetchServiceById,
    createService,
    updateService,
    deleteService
};
